import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=6c376ed0&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=6c376ed0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c376ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c376ed0')) {
      api.createRecord('6c376ed0', component.options)
    } else {
      api.reload('6c376ed0', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=6c376ed0&scoped=true", function () {
      api.rerender('6c376ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/challenge-friends/views/notifications.vue"
export default component.exports